const URL = {
    // FIXED: ME
    development: {
        // API: "http://192.168.100.9:7004" //尤静本地
        API: "http://sinograin.otto.xin" //奥托生产


        // API: "http://web-test.infocore.top/admin" //测试

        // API:"https://service.seederindonesia.com" //印尼生产

        // API: "https://fts.seeder.pro"//生产
        // API: "http://web-test.infocore.top/admin" //原测试
        // API: "https://admin.seeder.pro"//原生产
    },

    production: {
        // API: "http://192.168.100.9:7004" //尤静本地
        API: "http://sinograin.otto.xin" //奥托生产

        // API: "http://web-test.infocore.top/admin" //测试

        // API:"https://service.seederindonesia.com" //印尼生产

        // API: "https://fts.seeder.pro"//生产
        // API:"http://web-test.infocore.top/admin" //原测试
        // API: "https://admin.seeder.pro"//原生产
    },
};

// const URL = {
//     // FIXED: ME
//     development: {
//         // API: '//cn.wdecloud.com',
//         API:"http://web-test.infocore.top/admin"
//     },

//     production: {
//         // API: '//cn.wdecloud.com',
//         API:"https://admin.seeder.pro"
//     },
// };

export default URL[process.env.NODE_ENV];

// const URL_MAP = {
//     'mh5.testing1.wdeduc.com': 'mapi.testing1.wdeduc.com', // 测试
//     'mh5.wdcloudnet.com': 'mapi.wdcloudnet.com', // 生产
// };

// const API = `${location.protocol}//${URL_MAP[location.host]
//     || 'mapi.testing1.wdeduc.com'}`;

// window.APP_BASE_URL = API;

// export default {
//     API,
// };